import React from 'react';

const Block = ({ children }) => {
  return <div className="block">{children}</div>;
};

export default Block;
